<template>
  <div>
    <div class="newsheader-contain">
      <div class="location-contain">
        您的位置：
        <router-link tag="a" to="/Home" class="home-title">首页</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="/News" class="home-title"
          >新闻中心</router-link
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ><router-link tag="a" to="/News/1" class="news-name"
          >公司新闻</router-link
        >
      </div>
    </div>
    <div class="news-contain">
      <div class="news-chunk">
        <div class="news-left">
          <h1 class="news-title">2020年为什么这么多医疗器械公司一直招人？</h1>
          <div class="news-date">
            2021年03月15日 05:26<span>媒体来源：网络</span>
          </div>
          <div class="news-side">
            年后医疗器械招聘猛增，尤其是医疗器械维修工程师岗位，我所在的X射线细分领域来说，具体有以下几方面：
          </div>
          <div class="news-text1">
            首先，在疫情期间，DR设备的采购在3-4月份进入了峰值。特别是移动机的采购需求量猛增。比如说纽约州在3月份，一次就订购了1000多套的Caresteam的Mobile
            DR机器。再比如说国内的宝润，本身做移动机主机厂，今年的效益也跟随者猛增。销售的增加，与之对应的自然而然也就是对人员的需求大增。
          </div>
          <div class="new-images">
            <img
              src="../../../static/images/news6.png"
              alt="2020年为什么这么多医疗器械公司一直招人？"
            />
          </div>
          <div class="news-text2">其次，国家政策的支持。</div>
          <div class="news-text2">比如说关于医保制度的优化。</div>
          <div class="news-text2">
            再比如说，疫情期间，大型医疗设备注册的绿色通道，都让很多设备/主机厂兴奋起来，千载难逢的好时机，大干快上，也对人员需求尤其是产品注册方面有了较大的需求。
          </div>
          <div class="news-text2">再有就是产品的迭代了</div>
          <div class="news-text2">
            X射线诞生这么多年，比较大的一次技术变革，也就是从传统的胶片，变化为数字胶片了，有点类似于胶卷变为数码相机，其他时候更多的都是些基础参数的短暂升级。但是近期随着计算机性能的提升，大数据/AI的发展，在应用方面的变化和发展突飞猛进。比如说TOMO，3D
            DR技术实现的可行性，人工智能的诊断技术，机器人治疗等，都有了产品化的方向，甚至已经有了产品，在快速扩张器也会对人员的发展有较高的需求。
          </div>
          <div class="news-text2">
            这种短时间的快速提升或人员需求，有点类似于“打鸡血”，从DR这个市场看，市场的容量虽然会不断增长。包括生产、销售、售后及后期的维修工程人员现在已经大幅度招人。而且维修工程人员大概会后延两到三年有一个爆发期，器械的维保、故障维修成为行业主要课题。
          </div>
          <div class="news-bottom">
            <div class="roll-left" @click="leftClick">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </div>
            <div class="content-left">
              <transition name="left2" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/2'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left3" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/3'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left4" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/4'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left5" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/5'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
              <transition name="left6" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneroneIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneroneIndex].url == '/News/6'"
                >
                  {{ bannerData[banneroneIndex].name }}
                </router-link>
              </transition>
            </div>
            <div class="content-right">
              <transition name="right2" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/2'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right3" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/3'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right4" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/4'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right5" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/5'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
              <transition name="right6" mode="out-in">
                <router-link
                  tag="a"
                  :to="bannerData[banneronetwoIndex].url"
                  class="transition-text"
                  v-if="bannerData[banneronetwoIndex].url == '/News/6'"
                >
                  {{ bannerData[banneronetwoIndex].name }}
                </router-link>
              </transition>
            </div>
            <div class="roll-right" @click="rightClick">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="news-right">
          <div class="relevant-content">相关内容</div>
          <div class="relatedcontent">
            <router-link
              tag="a"
              :to="item.url"
              class="relatedtab"
              v-for="(item, index) in tabData"
              :key="index"
            >
              {{ item.name }}
            </router-link>
          </div>
          <div class="underline"></div>
          <router-link tag="a" to="/News/6">
            <div class="journalism-title">
              前海高扬联合创办并授牌100个中心...
            </div>
            <div class="journalism-name">
              2021年4月10日，在第十一届中国医疗设备行业数据发布大会上，《中国医疗设备》杂志社作为创始人...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/2">
            <div class="journalism-title">
              如何使医疗设备发挥出最佳的功能...
            </div>
            <div class="journalism-name">
              医疗设备是医院的物质基础，是现代化程度的重要标志，在医疗诊断过程中发挥着举足轻重的...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/3">
            <div class="journalism-title">
              医疗器械行业趋势及设备维修技术探讨
            </div>
            <div class="journalism-name">
              根据医疗器械相关法规，医疗器械使用单位对需要定期检查、检验、校准、保养、维护的医疗....
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/4">
            <div class="journalism-title">
              医疗器械的售后维修服务正逐渐成为...
            </div>
            <div class="journalism-name">
              随着近年来医疗器械产品与信息技术的不断升级，第三方医疗器械维修公司也纷纷依托大数据...
            </div>
          </router-link>
          <div class="underline"></div>
          <router-link tag="a" to="/News/5">
            <div class="journalism-title">医疗设备日常巡检保养的重要性</div>
            <div class="journalism-name">
              当前医院医疗设备故障很大一部分是由于巡检保养没有到位的原因引起的，完善医疗设备巡检...
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/bottom";
export default {
  components: {
    bottom
  },
  data() {
    return {
      tabData: [
        { name: "全部", url: "/news" },
        { name: "医疗资讯", url: "/news?type=医疗资讯" },
        { name: "培训中心", url: "/news?type=培训中心" }
      ],
      bannerData: [
        {
          name: "前海高扬联合创办并授牌100个中心城市的线下实体...",
          url: "/News/6"
        },
        {
          name: "如何使医疗设备发挥出最佳的功能日益重要",
          url: "/News/2"
        },
        { name: "医疗器械行业趋势及设备维修技术探讨", url: "/News/3" },
        {
          name: "医疗器械的售后维修服务正逐渐成为下一个风口",
          url: "/News/4"
        },
        { name: "医疗设备日常巡检保养的重要性", url: "/News/5" }
      ],
      banneroneIndex: 0,
      banneronetwoIndex: 1
    };
  },
  methods: {
    leftClick() {
      if (this.banneroneIndex == 0) {
        this.banneroneIndex = 3;
        this.banneronetwoIndex = 4;
      } else if (this.banneroneIndex == 1) {
        this.banneroneIndex = 4;
        this.banneronetwoIndex = 0;
      } else if (this.banneroneIndex == 2) {
        this.banneroneIndex = 0;
        this.banneronetwoIndex = 1;
      } else if (this.banneroneIndex == 3) {
        this.banneroneIndex = 1;
        this.banneronetwoIndex = 2;
      } else if (this.banneroneIndex == 4) {
        this.banneroneIndex = 2;
        this.banneronetwoIndex = 3;
      }
    },
    rightClick() {
      if (this.banneroneIndex == 0) {
        this.banneroneIndex = 2;
        this.banneronetwoIndex = 3;
      } else if (this.banneroneIndex == 1) {
        this.banneroneIndex = 3;
        this.banneronetwoIndex = 4;
      } else if (this.banneroneIndex == 2) {
        this.banneroneIndex = 4;
        this.banneronetwoIndex = 0;
      } else if (this.banneroneIndex == 3) {
        this.banneroneIndex = 0;
        this.banneronetwoIndex = 1;
      } else if (this.banneroneIndex == 4) {
        this.banneroneIndex = 1;
        this.banneronetwoIndex = 2;
      }
    }
  }
};
</script>

<style scoped lang="less">
.newsheader-contain {
  width: 100%;
  height: 48px;
  background: #f8f8f8;
  .location-contain {
    width: 1170px;
    height: 48px;
    margin: 0 auto;
    line-height: 56px;
    color: #666666;
    font-size: 12px;
    .fa-angle-right {
      margin: 0 5px;
    }
    .home-title {
      cursor: pointer;
      color: #666666;
      &:hover {
        color: #3488ea;
      }
    }
    .news-name {
      cursor: pointer;
      color: #3488ea;
    }
  }
}
.news-contain {
  width: 1170px;
  margin: 0 auto;
  padding: 40px 0 50px 0;
  .news-chunk {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .news-left {
      width: 68%;
      .news-title {
        color: #444444;
        font-size: 18px;
        line-height: 10px;
        font-weight: 500;
      }
      .news-date {
        color: #999999;
        font-size: 12px;
        margin-top: 8px;
        span {
          margin-left: 20px;
        }
      }
      .news-side {
        width: 100%;
        padding: 40px 0;
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        border-bottom: 1px solid #e5e5e5;
      }
      .news-text1 {
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
        margin-top: 20px;
      }
      .news-text2 {
        margin-top: 25px;
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        line-height: 24px;
      }
      .new-images {
        width: 100%;
        margin-top: 20px;
        img {
          width: 100%;
          height: 280px;
          display: block;
        }
      }
      .news-bottom {
        width: 100%;
        height: 120px;
        background: #f9f9f9;
        display: flex;
        flex-direction: row;
        margin-top: 50px;

        .fa {
          color: #b7b7b7;
          font-size: 20px;
        }
        .roll-left {
          width: 8%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.5s;
          .fa-angle-left {
            transition: all 0.5s;
          }
        }
        .roll-left:hover {
          background: #3488ea;
          transition: all 0.5s;
          .fa-angle-left {
            color: #ffffff;
            transition: all 0.5s;
          }
        }
        .content-left {
          width: 42%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666666;
          font-size: 12px;
          font-weight: 400;
          .transition-text {
            cursor: pointer;
            overflow-y: auto;
            overflow-x: hidden;
            position: absolute;
            color: #666666;
            &:hover {
              color: #3488ea;
            }
          }
        }
        .content-right {
          width: 42%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #666666;
          font-size: 12px;
          font-weight: 400;
          .transition-text {
            cursor: pointer;
            color: #666666;
            overflow-y: auto;
            overflow-x: hidden;
            position: absolute;
            &:hover {
              color: #3488ea;
            }
          }
        }
        .roll-right {
          width: 8%;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.5s;
          .fa-angle-right {
            transition: all 0.5s;
          }
        }
        .roll-right:hover {
          background: #3488ea;
          transition: all 0.5s;
          .fa-angle-right {
            color: #fff;
            transition: all 0.5s;
          }
        }
      }
    }
    .news-right {
      width: 28%;
      .relevant-content {
        color: #666666;
        font-size: 16px;
        font-weight: 300;
        line-height: 24px;
      }
      .relatedcontent {
        width: 90%;
        height: 85px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .relatedtab {
          width: 30%;
          height: 28px;
          border: 1px solid #e5e5e5;
          text-align: center;
          line-height: 28px;
          color: #666666;
          font-size: 12px;
          cursor: pointer;
        }
        .relatedtab:hover {
          background: #3488ea;
          border: 1px solid #3488ea;
          color: #ffffff;
        }
      }
      .underline {
        width: 100%;
        height: 1px;
        background: #e5e5e5;
      }
      .journalism-title {
        color: #444444;
        font-size: 18px;
        font-weight: 300;
        margin-top: 20px;
        cursor: pointer;
        &:hover {
          color: #3488ea;
        }
      }
      .journalism-name {
        color: #666666;
        font-size: 14px;
        font-weight: 300;
        margin-top: 20px;
        line-height: 24px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
}

// .left1-enter {
//   opacity: 0;
// }
// .left2-enter {
//   opacity: 0;
// }
// .left3-enter {
//   opacity: 0;
// }
// .left4-enter {
//   opacity: 0;
// }
// .left5-enter {
//   opacity: 0;
// }
// .left1-enter-active {
//   transition: opacity 1s;
// }
// .left2-enter-active {
//   transition: opacity 1s;
// }
// .left3-enter-active {
//   transition: opacity 1s;
// }
// .left4-enter-active {
//   transition: opacity 1s;
// }
// .left5-enter-active {
//   transition: opacity 1s;
// }

// .left1-leave-to {
//   transition: 1s;
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .left2-leave-to {
//   transition: 1s;
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .left3-leave-to {
//   transition: 1s;
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .left4-leave-to {
//   transition: 1s;
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }
// .left5-leave-to {
//   transition: 1s;
//   opacity: 0;
//   transform: translateY(30px);
//   position: absolute;
// }

.left2-enter,
.right2-enter {
  opacity: 1;
}
.left3-enter,
.right3-enter {
  opacity: 1;
}
.left4-enter,
.right4-enter {
  opacity: 1;
}
.left5-enter,
.right5-enter {
  opacity: 1;
}
.left6-enter,
.right6-enter {
  opacity: 1;
}

.left2-enter-active,
.left2-leave-active,
.right2-enter-active,
.right2-leave-active {
  transition: all 1s;
}
.left3-enter-active,
.left3-leave-active,
.right3-enter-active,
.right3-leave-active {
  transition: all 1s;
}
.left4-enter-active,
.left4-leave-active,
.right4-enter-active,
.right4-leave-active {
  transition: all 1s;
}
.left5-enter-active,
.left5-leave-active,
.right5-enter-active,
.right5-leave-active {
  transition: all 1s;
}
.left6-enter-active,
.left6-leave-active,
.right6-enter-active,
.right6-leave-active {
  transition: all 1s;
}

.left2-enter,
.left2-leave-to,
.right2-enter,
.right2-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left3-enter,
.left3-leave-to,
.right3-enter,
.right3-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left4-enter,
.left4-leave-to,
.right4-enter,
.right4-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left5-enter,
.left5-leave-to,
.right5-enter,
.right5-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
.left6-enter,
.left6-leave-to,
.right6-enter,
.right6-leave-to {
  opacity: 0;
  transform: translateY(30px);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/News/NewsDetails1.vue